import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler } from "reactstrap"; 
import { NavLink } from "react-router-dom";  
import Scrollspy from "react-scrollspy";
import "./IndexBackground.css";
import REALLogo1 from "../assets/RealEnglishImages/REALLogo1.png";
import REALAwards from "../assets/RealEnglishImages/REALAwards1.png";
const Navbar = () => {
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [navClass, setNavClass] = useState("");

    const toggle = () => setIsOpenMenu(!isOpenMenu);

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation);
        return () => window.removeEventListener("scroll", scrollNavigation);
    }, []);

    const scrollNavigation = () => {
        setNavClass(window.scrollY > 50 ? "is-sticky" : "");
    };

    const handleNavigation = (id) => {
        setTimeout(() => {
            const section = document.getElementById(id);
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100);
    };

    return (
        <nav className={`navbar navbar-expand-lg vw-100 navbar-landing fixed-top py-0 ${navClass} bg-white`} id="navbar">
            <Container>
                <NavLink to="/HomePage" className="navbar-brand">
                    <img src={REALLogo1} className="card-logo card-logo-dark" alt="logo dark" height="80"/>
                </NavLink>
                <NavLink to="/ELT-ExcellenceAwards" className="navbar-brand">
                    <img src={REALAwards} className="card-logo card-logo-dark" alt="logo dark" height="50"/>
                </NavLink>

                <NavbarToggler className="navbar-toggler py-0 fs-20 text-body" onClick={toggle}>
                    <i className="mdi mdi-menu"></i>
                </NavbarToggler>

                <Collapse isOpen={isOpenMenu} className="navbar-collapse">
                    <Scrollspy
                        offset={-18}
                        items={["AboutUs", "OurTeachers", "OurSchool", "BilingualProject", "Reviews"]}
                        currentClassName="active"
                        className="navbar-nav ms-5 ps-5 mt-2 mt-lg-0"
                    >
                        <li className="nav-item">
                            <NavLink to="/AboutUs" className="nav-link" onClick={() => handleNavigation("AboutUs")}>
                                About Us
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/OurTeachers" className="nav-link" onClick={() => handleNavigation("OurTeachers")}>
                                Our Teachers
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/OurSchool" className="nav-link" onClick={() => handleNavigation("OurSchool")}>
                                Our School
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/Gallery" className="nav-link" onClick={() => handleNavigation("Gallery")}>
                                Gallery
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/BilingualProject" className="nav-link" onClick={() => handleNavigation("BilingualProject")}>
                                The Bilingual Project
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/Reviews" className="nav-link" onClick={() => handleNavigation("Reviews")}>
                                Reviews
                            </NavLink>
                        </li>

                    </Scrollspy>
                </Collapse>
            </Container>
        </nav>
    );
};

export default Navbar;
